import { EMAIL_VALIDATOR } from "./validators.js";

/**
 * Get tuple with arrays of valid and invalid emails from the string.
 * @param {string} emailList - The string with emails, separated by comma, semicolon, space or newline character.
 * @returns {Array<Array<String>>} - Tuple with validated email list and unvalidated email list.
 */
export const getEmailListFromString = (emailList) => {
  const separatorsReg = /,| |;|, |\n/;

  const validateEmail = (email) => EMAIL_VALIDATOR.test(email.toLowerCase());

  const foundEmails = emailList
    .split(separatorsReg)
    .map((email) => email.trim());

  if (!foundEmails.length) {
    return [[], []];
  }

  const validEmailList = foundEmails.filter((email) => validateEmail(email));
  const invalidEmailList = foundEmails.filter(
    (email) => !validateEmail(email) && email.trim().length > 0
  );

  return { validEmailList, invalidEmailList };
};
